import { get } from 'lodash';
import { graphql, StaticQuery } from 'gatsby';
import React, { Component } from 'react';
import styled from 'styled-components';
import ImageInContext from '../Media/ImageInContext';
import { ButtonLink } from '../Inputs/Button.span';
import P from '../Type/Paragraph.p';

class TestimonialsPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedIndex: Math.floor(Math.random() * 19),
    };
  }

  changeFocus(index) {
    this.setState({ focusedIndex: index });
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query TestimonialPreviewQuery {
            allContentfulReview(
              filter: { featured: { eq: true } }
              sort: { fields: [date], order: ASC }
              limit: 20
            ) {
              edges {
                node {
                  reviewer
                  featured
                  date
                  review {
                    review
                  }
                  causeForDebt {
                    causeForDebt
                  }
                  adviceForOthers {
                    adviceForOthers
                  }
                  afterBankruptcy {
                    afterBankruptcy
                  }
                  image {
                    ...ImageNode
                  }
                }
              }
            }
          }
        `}
        render={data => {
          const { focusedIndex } = this.state;
          const text = (r => get(r, 'node.review.review') || get(r, 'node.adviceForOthers.adviceForOthers')
            || get(r, 'node.adviceForOthers.adviceForOthers') || get(r, 'node.causeForDebt.causeForDebt') || '')(data.allContentfulReview.edges[focusedIndex]).trim();

          return (
            <TestimonialWrapper>
              {Array.prototype.map.call(data.allContentfulReview.edges.map(e => e.node), (review, index) => {
                return index <= 9 && (
                  <div key={index} className={index === focusedIndex ? 'focus' : ''} onClick={() => this.changeFocus(index)}>
                    <ImageInContext
                      alt={review.image.altText}
                      src={get(review, 'image.image.file.url')}
                      fluid={get(review, 'image.image.fluid')}
                    />
                  </div>
                );
              })}
              <div className="testimonial-text">
                <P><a aria-busy="false" href="/fresh-starts/">"{text.length > 240 ? `${text.slice(0, text.slice(0, 240).lastIndexOf('.'))}.` : text}"</a></P>
              </div>
              <div className="testimonial-cta">
                <ButtonLink href="/fresh-starts/" buttonType="white" inverted>Learn More From {data.allContentfulReview.edges[focusedIndex].node.reviewer}</ButtonLink>
              </div>
              {Array.prototype.map.call(data.allContentfulReview.edges.map(e => e.node), (review, index) => {
                return index > 9 && (
                  <div key={index} className={index === focusedIndex ? 'focus' : ''} onClick={() => this.changeFocus(index)}>
                    <ImageInContext
                      alt={review.image.altText}
                      src={get(review, 'image.image.file.url')}
                      fluid={get(review, 'image.image.fluid')}
                    />
                  </div>
                );
              })}
            </TestimonialWrapper>
          );
        }}
      />
    );
  }
}

const TestimonialWrapper = styled.div`
  display: grid;
  grid-gap: 0;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(2, 1fr) 124px 72px repeat(2, 1fr);
  border-radius: 8px;
  overflow: hidden;
  @media (max-width: 45em) {
    border-radius: 0;
    grid-template-rows: repeat(2, 1fr) 210px 80px repeat(2, 1fr);
    margin-left: -1.5em;
    margin-right: -1.5em;
  }
  & > div:not(.testimonial-text) {
    overflow: hidden;
    background: ${({ theme }) => theme.colors.brand['200']};
    & > div {
      width: 100%;
      height: 100%;
    }
    img {
      mix-blend-mode: lighten;
    }
  }

  .testimonial-text, .testimonial-cta {
    grid-column-start: 1;
    grid-column-end: 6;
    border-left: 4px solid ${({ theme }) => theme.colors.brand['100']};
    border-right: 4px solid ${({ theme }) => theme.colors.brand['100']};
    background: ${({ theme }) => theme.colors.brand['200']};
    text-align: center;
  }

  .testimonial-text {
    padding: 1em 1.5em 0;
    display: flex;
    & > p {
      color: white;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      & > a, & > a:active, & > a:visited {
        color: white;
        font-weight: 700;
      }
    }
  }

  .testimonial-cta {
    padding: 0 1.5em 1.5em;
    display: flex;
    justify-content: center;
    button {
      font-weight: 700;
    }
  }
`;

export default TestimonialsPreview;